import React from "react";

export type CheckBoxProps = {
  id:string
  children?: React.ReactNode;
  className?: string;
  inputClassName?: string;
  color?: "blue" | "green" | "red" | "yellow" | "indigo" ;
  size?: "sm" | "md" | "lg";
  value?:boolean;
  onChange?:any;
  [key:string]:any;
};

const style = {
  sizes: {
    sm: "h-4 w-4",
    md: "h-5 w-5",
    lg: "h-6 w-6",
  },
  colors: {
    blue: "text-blue-600 focus:ring-blue-500",
    green: "text-green-600 focus:ring-green-500",
    red: "text-red-600 focus:ring-red-500",
    yellow: "text-yellow-600 focus:ring-yellow-500",
    indigo: "text-indigo-600 focus:ring-indigo-500",
  },
};

export const CheckBox = ({
  id,
  children,
  className,
  inputClassName,
  color = "indigo",
  size = "md",
  value,
  onChange,
  ...props
}: CheckBoxProps) => {
  return (
    <div className={`flex ${className}`}>
      <div className="flex pr-2 h-5 items-center">
        <input
          type="checkbox"
          checked={value}
          onChange={onChange}
          {...props}
          className={`${style.sizes[size]} rounded border-gray-300 ${style.colors[color]} ${inputClassName}`}
        />
      </div>
      <div className="text-gray-500 font-medium text-sm">
        {children}
      </div>
    </div>
  );
};